<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item prop="userId" >
        <span slot="label" >
          <a-tooltip>
            {{$t('主播申请绑定工会记录.主播id{user_user.id}')}}<template slot="title">{{$t('主播申请绑定工会记录.主播id{user_user.id}')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.userId"  :placeholder="$t('通用.输入.请输入')+$t('主播申请绑定工会记录.主播id{user_user.id}')" />
      </a-form-model-item>
      <a-form-model-item prop="tradeId" >
        <span slot="label" >
          <a-tooltip>
            {{$t('主播申请绑定工会记录.工会表{zb_trade_union.id}')}}<template slot="title">{{$t('主播申请绑定工会记录.工会表{zb_trade_union.id}')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.tradeId"  :placeholder="$t('通用.输入.请输入')+$t('主播申请绑定工会记录.工会表{zb_trade_union.id}')" />
      </a-form-model-item>
      <a-form-model-item prop="status" >
        <span slot="label" >
          <a-tooltip>
            {{$t('主播申请绑定工会记录.审核状态 0平台待审核 1 平台审核失败  2工会待审核 3工会审核失败')}}<template slot="title">{{$t('主播申请绑定工会记录.审核状态 0平台待审核 1 平台审核失败  2工会待审核 3工会审核失败')}}</template>
          </a-tooltip>
        </span>
      </a-form-model-item>
      <a-form-model-item prop="bindingStatus" >
        <span slot="label" >
          <a-tooltip>
            {{$t('主播申请绑定工会记录.是否绑定 0 否 1是')}}<template slot="title">{{$t('主播申请绑定工会记录.是否绑定 0 否 1是')}}</template>
          </a-tooltip>
        </span>
      </a-form-model-item>
      <a-form-model-item prop="reasonPlatform" >
        <span slot="label" >
          <a-tooltip>
            {{$t('主播申请绑定工会记录.平台审核失败原因')}}<template slot="title">{{$t('主播申请绑定工会记录.平台审核失败原因')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.reasonPlatform" :maxLength="100" :placeholder="$t('通用.输入.请输入')+$t('主播申请绑定工会记录.平台审核失败原因')" />
      </a-form-model-item>
      <a-form-model-item prop="reasonTrade" >
        <span slot="label" >
          <a-tooltip>
            {{$t('主播申请绑定工会记录.工会审核失败原因')}}<template slot="title">{{$t('主播申请绑定工会记录.工会审核失败原因')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.reasonTrade" :maxLength="100" :placeholder="$t('通用.输入.请输入')+$t('主播申请绑定工会记录.工会审核失败原因')" />
      </a-form-model-item>
      <a-form-model-item prop="erminationStatus" >
        <span slot="label" >
          <a-tooltip>
            {{$t('主播申请绑定工会记录.解约状态 0未申请 1待审核 2审核成功 3审核失败')}}<template slot="title">{{$t('主播申请绑定工会记录.解约状态 0未申请 1待审核 2审核成功 3审核失败')}}</template>
          </a-tooltip>
        </span>
      </a-form-model-item>
      <a-form-model-item prop="erminationReason" >
        <span slot="label" >
          <a-tooltip>
            {{$t('主播申请绑定工会记录.解约失败原因')}}<template slot="title">{{$t('主播申请绑定工会记录.解约失败原因')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.erminationReason" :maxLength="100" :placeholder="$t('通用.输入.请输入')+$t('主播申请绑定工会记录.解约失败原因')" />
      </a-form-model-item>
      <a-form-model-item prop="remark" >
        <span slot="label" >
          <a-tooltip>
            {{$t('主播申请绑定工会记录.备注')}}<template slot="title">{{$t('主播申请绑定工会记录.备注')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.remark" :placeholder="$t('通用.输入.请输入')" type="textarea" allow-clear />
      </a-form-model-item>
      <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
        <img alt="example" style="width: 100%" :src="previewUrl" />
      </a-modal>
      <a-modal :visible="previewVideoVisible" :footer="null" @cancel="previewVideoCancel">
        <video style="width: 100%" :src="previewUrl" ref="myVideo"
               :poster="previewUrl + '?x-oss-process=video/snapshot,t_0,f_jpg'" :controls="true"></video>
      </a-modal>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('通用.按钮.保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('通用.按钮.取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getApplyTradeUnion, addApplyTradeUnion, updateApplyTradeUnion } from '@/api/trade/applyTradeUnion'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";


export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    CustomDictTag,
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      // 表单参数
      form: {
        id: null,

        userId: null,

        tradeId: null,

        status: 0,

        bindingStatus: 0,

        reasonPlatform: null,

        reasonTrade: null,

        erminationStatus: 0,

        erminationReason: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    previewVideoCancel() {
      this.previewVideoVisible = false;
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        tradeId: null,
        status: 0,
        bindingStatus: 0,
        reasonPlatform: null,
        reasonTrade: null,
        erminationStatus: 0,
        erminationReason: null,
        createTime: null,
        remark: null,
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('通用.文本.添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getApplyTradeUnion({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('通用.文本.修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('通用.文本.修改成功')
            updateApplyTradeUnion(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('通用.文本.修改成功')
            addApplyTradeUnion(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
